import { gql } from '@apollo/client';

export const Q_SESSION = gql`
  query sessionAlien($input: InputId!) {
    sessionAlien(input: $input) {
      id
      name
      locked
      user {
        id
        accountNo
        name
        phone
        state
          email
        role {
          id
          name
          clientTier1 {
            id
            clientType {
              id
              name
            }
          }
          clientTier2 {
            id
            clientType {
              id
              name
            }
          }
            permissions {
                key
            }
        }
        profile {
          id
          darkTheme
          photo {
            fileName
          }
        }
        agent {
          id
          lockPassPhoto
          clockFaceFailureCount
          faceVerificationStatus
          faceVerifiedAt
          teams {
            id
            leader {
              id
            }
          }
        }
      }
    }
  }
`;

export const Q_SESSIONS = gql`
  query sessions($input: InputPaginatedRecords!) {
    sessions(input: $input) {
      count
      rows {
        index
        id
        locked
        expireString
        created
        user {
          id
          name
          accountNo
          profile {
            darkTheme
            photo {
              fileName
            }
          }
          role {
            name
            clientTier1 {
              clientType {
                id
                name
              }
            }
            clientTier2 {
              clientType {
                name
              }
            }
          }
        }
      }
    }
  }
`;

export const Q_SESSION_SELF = gql`
  query sessionSelf {
    sessionSelf {
      userVerification {
        isVerified
        isMatched
          attemptCount
          phoneVerified
      }
      profileCompleteness
      user {
        id
        name
        phone
        email
        profile {
          photo {
            id
            fileName
          }
        }
        role {
          name
          clientTier1 {
            id
          }
          clientTier2 {
            id
            clientTier1 {
              id
            }
          }
        }
        agent {
          id
          lockPassPhoto
          clockFaceFailureCount
          faceVerificationStatus
          faceVerifiedAt
        }
      }
    }
  }
`;
export const Q_AGENT_PROFILE = gql`
  query sessionSelf {
    sessionSelf {
        userVerification {
            phoneVerified
        }
      user {
        id
          phone
          email
          name
        agent {
          id
        }
        profile {
            preferredLocationId
            workOutsideCounty
            travelDistanceWilling
            jobTypePreferred
            workSchedulePreferred
            workingHoursPreferred
            multidayAssignments
            sameDayJobs
            highestEducationLevel
            yearsOfWorkExperience
            experienceAreas
            digitalSkills
            resumeFile
            phoneType
            internetAccess
            connectivityIssues
            hearAboutUs
            consent
            photo {
                fileName
            }
        }
      }
    }
  }
`;

export const Q_AGENT_LEADING_TEAMS = gql`
  query agentLeadingTeams($input: InputId!) {
    agentLeadingTeams(input: $input) {
      id
      name
    }
  }
`;
